module.exports = __webpack_public_path__ + "static/media/01.8419830f.png";